import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
import { SessionService } from "src/app/core/survey/shared/services/session.service";
import { User } from "../models/user";
import { TokenService } from "../token.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit, OnDestroy {
  redirectedFromUrl: string;

  constructor(
    private router: Router,
    private tokenService: TokenService,
    private sessionService: SessionService,
    private activeRoute: ActivatedRoute
  ) {}
  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {
    this.tokenService.deleteToken();
    this.sessionService.clearAll();

    this.activeRoute.queryParams.pipe(first()).subscribe((params) => {
      if (params.redirectTo !== "login")
        this.redirectedFromUrl = params.redirectTo;
    });
  }

  onUserLoggedIn(user: User) {
    this.navigateUser();
  }

  navigateUser() {
    if (this.tokenService.isAdmin())
      this.router.navigate([this.redirectedFromUrl || "welcome"]);
    else this.router.navigate([this.redirectedFromUrl || "building-table"]);
  }
}
